// Api
import {getInvitationCompanyTree} from "@/api/emergencyManage/company";

export default {
    data() {
        return {
            loading: false, // loading
            loadingText: "数据正在加载中...", // loading 文字

            /* "部门架构"树 数据 */
            departmentId: "", // 选中的部门id

            /* "已分配"部门树 数据 */
            leftData: [], // 树数据
            leftFilterText: "", // 过滤搜索关键字
            leftIsSearch: true, // nodata是否为search模式
            leftNodataText: "请在左侧选择部门进行查看和操作", // nodata提示文字
            leftDataTotal: 0, // 总数量(车辆/设备/标签/IC卡/门店)
            leftCheckedData: [], // 选中的数据列表
            leftLimbCheckedId: "", // 数据枝干 id
            leftCheckedAll: false, // 全选，此全选是选择筛选之后的
            leftIndeterminate: false, // 全选选择框状态

            rightData: [], // 树数据
            rightFilterText: "", // 过滤搜索关键字
            rightIsSearch: true, // nodata是否为search模式
            rightNodataText: "请在左侧选择部门进行查看和操作", // nodata提示文字
            rightDataTotal: 0, // 总数量(车辆/设备/标签/IC卡/门店)
            rightCheckedData: [], // 选中的数据列表
            rightLimbCheckedId: "", // 数据枝干 id
            rightCheckedAll: false, // 全选，此全选是选择筛选之后的
            rightIndeterminate: false, // 全选选择框状态

            count: 0,
            pass: [], // 应急企业树
            toBeInvited: [], // 待邀请应急企业树
            notPass: [], //非应急企业树

            departmentTreeList: [], // 部门树列表
            currentDepartment: null, // 当前选中的部门节点
            higherDepartmentId: null // 当前选中的部门的上级部门id
        };
    },

    mounted() {
        this.getAllTree();
        // this.getLeftTree();
        // this.getRightTree();
    },

    methods: {
        // 获取页面所有下拉树
        async getAllTree() {
            try {
                this.loading = true;
                let {code, result} = await getInvitationCompanyTree();
                this.count = 0;
                this.departmentTreeList = [];
                this.leftData = []; // 待邀请应急企业树
                if (code === 1 && result) {
                    this.count = result.count;
                    if (Array.isArray(result.pass)) {
                        this.getData(result.pass);
                        // pass = result.pass);
                    }
                    if (Array.isArray(result.toBeInvited)) {
                        this.setLeftTree(result.toBeInvited);
                        // pass = result.pass);
                    }
                    if (Array.isArray(result.notPass)) {
                        this.setRightTree(result.notPass);
                        // pass = result.pass);
                    }
                }
            } catch (e) {
                console.log(e);
            } finally {
                this.loading = false;
            }

            // this.pass = pass;
            // this.toBeInvited = toBeInvited;
            // this.notPass = notPass;
        },

        // 根据部门id获取"已分配"树
        // getLeftTree() {
        //   try {
        //     // let res = await this.apiTree(params);
        //     // 测试 待删除 -------
        //     this.setLeftTree(res); // 渲染"已分配"树
        //   } catch (error) {
        //     console.log(error);
        //   } finally {

        //   }
        // },
        getData(res) {
            this.departmentTreeList = res;
        },
        // 获取右侧列表"全部"数据
        // getRightTree(orgId) {
        //   try {
        //     let params = { orgId };
        //     // let res = await this.apiTree(params);
        //     let res = {
        //       code: 1,
        //       message: "ok",
        //       result: {
        //         data: [
        //           {
        //             children: [
        //               {
        //                 children: [],
        //                 disabled: true,
        //                 id: 11111,
        //                 label: "一区",
        //                 pid: -109639,
        //                 vehicleCount: 0
        //               },
        //               {
        //                 children: [
        //                   {
        //                     children: [],
        //                     disabled: false,
        //                     id: 21,
        //                     label: "大师风范",
        //                     orgId: 0,
        //                     orgName: "",
        //                     pid: 22222,
        //                     vehicleId: 0
        //                   }
        //                 ],
        //                 disabled: true,
        //                 id: 22222,
        //                 label: "二区",
        //                 orgId: 0,
        //                 orgName: "",
        //                 pid: -109639,
        //                 vehicleId: 0
        //               },
        //               {
        //                 children: [
        //                   {
        //                     children: [],
        //                     disabled: false,
        //                     id: 32,
        //                     label: "测试额外人发",
        //                     orgId: 0,
        //                     orgName: "",
        //                     pid: 33333,
        //                     vehicleId: 0
        //                   },
        //                   {
        //                     children: [],
        //                     disabled: false,
        //                     id: 33,
        //                     label: "士大夫1发",
        //                     orgId: 0,
        //                     orgName: "",
        //                     pid: 33333,
        //                     vehicleId: 0
        //                   }
        //                 ],
        //                 disabled: true,
        //                 id: 33333,
        //                 label: "三区",
        //                 orgId: 0,
        //                 orgName: "",
        //                 pid: -109639,
        //                 vehicleId: 0
        //               }
        //             ],
        //             disabled: true,
        //             id: -109639,
        //             label: "郑州市冷链政府平台",
        //             pid: -107252,
        //             vehicleCount: 0
        //           }
        //         ],
        //         count: 3
        //       }
        //     };
        //     // 测试 待删除 -------
        //     this.setRightTree(res); // 渲染"已分配"树
        //   } catch (error) {
        //     console.log(error);
        //   } finally {
        //   }
        // },
        // "已分配"树节点点击事件
        handleLeftGetLimb(val) {
            let id = "";
            if (!val.disabled) {
                id = "";
            } else {
                id = val.id;
            }
            this.leftLimbCheckedId = id;
        },
        handleRightGetLimb(val) {
            let id = "";
            if (!val.disabled) {
                id = "";
            } else {
                id = val.id;
            }
            this.rightLimbCheckedId = id;
        },

        // "已分配"树checkbox勾选改变回调
        handleLefGetNode(node, isChecked) {
            let {data} = this.$refs.departmentTree.getAllNodes();
            if (isChecked === false) {
                this.leftCheckedData = this.leftCheckedData.filter(
                    item => !(item.id === node.id && item.pid === node.pid)
                );
            } else {
                let checked = data;
                checked = this.leftCheckedData.concat(checked);
                let arr = [];
                checked.forEach(item => {
                    let exist = arr.find(
                        node => item.id === node.id && item.pid === node.pid
                    );
                    if (!exist) {
                        arr.push(item);
                    }
                });
                this.leftCheckedData = arr;
            }
            // 判断已分配树顶部"全选"checkbox的全选/半选状态
            this.leftCheckedAll = this.leftCheckedData.length === this.leftDataTotal;
            this.leftIndeterminate = !!(
                this.leftCheckedData.length &&
                this.leftCheckedData.length < this.leftDataTotal
            );
        },
        // "未分配"树checkbox勾选改变回调
        handleRightGetNode(node, isChecked) {
            let {data} = this.$refs.departRightTree.getAllNodes();
            if (isChecked === false) {
                this.rightCheckedData = this.rightCheckedData.filter(
                    item => !(item.id === node.id && item.pid === node.pid)
                );
            } else {
                let checked = data;
                checked = this.rightCheckedData.concat(checked);
                let arr = [];
                checked.forEach(item => {
                    let exist = arr.find(
                        node => item.id === node.id && item.pid === node.pid
                    );
                    if (!exist) {
                        arr.push(item);
                    }
                });
                this.rightCheckedData = arr;
            }
            // 判断已分配树顶部"全选"checkbox的全选/半选状态
            this.rightCheckedAll =
                this.rightCheckedData.length === this.rightDataTotal;
            this.rightIndeterminate = !!(
                this.rightCheckedData.length &&
                this.rightCheckedData.length < this.rightDataTotal
            );
        },
        // "已分配"树顶部"全选"点击事件
        handleLeftCheckedAll(val) {
            if (this.leftData.length && this.$refs.departmentTree) {
                this.$refs.departmentTree.setAllNodeCheck(val); // 设置全选/全不选
                if (val) {
                    let {data: allChecked} = this.$refs.departmentTree.getAllNodes(); // 获取全选数据
                    this.leftCheckedData = allChecked;
                    this.leftIndeterminate = false;
                } else {
                    this.leftCheckedData = [];
                }
            } else {
                this.leftCheckedAll = false;
                this.leftIndeterminate = false;
                this.leftCheckedData = [];
            }
        },

        // "未分配全选"点击事件
        handleRightCheckedAll(val) {
            if (this.rightData.length && this.$refs.departRightTree) {
                this.$refs.departRightTree.setAllNodeCheck(val); // 设置全选/全不选
                if (val) {
                    let {data: allChecked} = this.$refs.departRightTree.getAllNodes(); // 获取全选数据
                    this.rightCheckedData = allChecked;
                    this.rightIndeterminate = false;
                } else {
                    this.rightCheckedData = [];
                }
            } else {
                this.rightCheckedAll = false;
                this.rightIndeterminate = false;
                this.rightCheckedData = [];
            }
        },

        // "已分配"树关键字搜索
        handleLeftFilter() {
            // 无搜索关键字、树无数据时
            if (
                !this.leftFilterText ||
                !this.leftData.length ||
                !this.$refs.departmentTree
            ) {
                return;
            }

            let res = this.$refs.departmentTree.queryTreeNodeByName(
                this.leftFilterText
            );
            if (Array.isArray(res) && res.length) {
                this.leftLimbCheckedId = "";
            } else {
                this.$message.warning("没有匹配到结果！");
            }
        },

        // "未分配"树关键字搜索
        handleRightFilter() {
            // 无搜索关键字、树无数据时
            if (
                !this.rightFilterText ||
                !this.rightData.length ||
                !this.$refs.departRightTree
            ) {
                return;
            }

            let res = this.$refs.departRightTree.queryTreeNodeByName(
                this.rightFilterText
            );
            if (Array.isArray(res) && res.length) {
                this.rightLimbCheckedId = "";
            } else {
                this.$message.warning("没有匹配到结果！");
            }
        },
        // 删除"已分配"树已选择的设备(el-popover中)
        handleDeleteLeftChecked(item) {
            // 删除el-popover列表中的节点
            this.leftCheckedData = this.leftCheckedData.filter(i => i.id !== item.id);
            // 取消选中车辆树中的节点
            let nodes = this.$refs["departmentTree"].queryTreeNodeByID(item.id);
            if (Array.isArray(nodes)) {
                nodes.forEach(n => {
                    this.$refs["departmentTree"].setNodeCheck(n, false);
                });
            }
            // 判断已分配树顶部"全选"checkbox的全选/半选状态
            this.leftCheckedAll = this.leftCheckedData.length === this.leftDataTotal;
            this.leftIndeterminate = !!(
                this.leftCheckedData.length &&
                this.leftCheckedData.length < this.leftDataTotal
            );
        },

        // 删除"未分配"树已选择的设备(el-popover中)
        handleDeleteRightChecked(item) {
            // 删除el-popover列表中的节点
            this.rightCheckedData = this.rightCheckedData.filter(
                i => i.id !== item.id
            );
            // 取消选中车辆树中的节点
            let nodes = this.$refs["departRightTree"].queryTreeNodeByID(item.id);
            if (Array.isArray(nodes)) {
                nodes.forEach(n => {
                    this.$refs["departRightTree"].setNodeCheck(n, false);
                });
            }
            // 判断已分配树顶部"全选"checkbox的全选/半选状态
            this.rightCheckedAll =
                this.rightCheckedData.length === this.rightDataTotal;
            this.rightIndeterminate = !!(
                this.rightCheckedData.length &&
                this.rightCheckedData.length < this.rightDataTotal
            );
        },

        // "已分配"树清除所有已选择的设备(el-popover中)
        handleLeftClearAll(name) {
            if (this.leftCheckedData.length > 0) {
                this.$confirm(`确定清空已选${name}？`, "提示", {
                    type: "warning",
                    closeOnClickModal: false,
                    closeOnPressEscape: false,
                    confirmButtonText: "确定",
                    cancelButtonText: "取消"
                })
                    .then(() => {
                        this.$refs.departmentTree.setAllNodeCheck(false);
                        this.leftCheckedData = [];
                        this.leftCheckedAll = false;
                        this.leftIndeterminate = false;
                    })
                    .catch(err => {
                        console.log(err);
                    });
            } else {
                this.$message.warning(`您未选择任何${name}！`);
            }
        },

        // "未分配"树清除所有已选择的设备(el-popover中)
        handleRightClearAll(name) {
            if (this.rightCheckedData.length > 0) {
                this.$confirm(`确定清空已选${name}？`, "提示", {
                    type: "warning",
                    closeOnClickModal: false,
                    closeOnPressEscape: false,
                    confirmButtonText: "确定",
                    cancelButtonText: "取消"
                })
                    .then(() => {
                        this.$refs.departRightTree.setAllNodeCheck(false);
                        this.rightCheckedData = [];
                        this.rightCheckedAll = false;
                        this.rightIndeterminate = false;
                    })
                    .catch(err => {
                        console.log(err);
                    });
            } else {
                this.$message.warning(`您未选择任何${name}！`);
            }
        },

        // 设置"已分配"树数据
        setLeftTree(res) {
            this.toBeInvited = res;
            this.leftData = this.handleData(res);
            // 判断nodata组件状态
            if (!res.length) {
                this.leftIsSearch = false;
                this.leftNodataText = "暂无数据";
            }

            // 选中当前选中的部门节点
            this.$nextTick(() => {
                if (res.length && this.$refs.departmentTree) {
                    let nodes = this.$refs.departmentTree.queryTreeNodeByID(res[0].id);
                    if (Array.isArray(nodes) && nodes[0]) {
                        this.leftLimbCheckedId = res[0].id; // 设置"已分配"树选中的部门id
                        this.$refs.departmentTree.setNodeSelect(nodes[0], true); // 设置该部门节点背景选中
                    }
                }
                this.leftDataTotal = this.$refs.departmentTree.getAllNodes(
                    false,
                    false
                ).data.length;
            });
        },

        // 设置右侧列表数据
        setRightTree(res) {
            this.rightData = this.handleData(res);
            // 判断nodata组件状态
            if (!res.length) {
                this.rightIsSearch = false;
                this.rightNodataText = "暂无数据";
            }

            // 选中当前选中的部门节点
            this.$nextTick(() => {
                if (res.length && this.$refs.departRightTree) {
                    let nodes = this.$refs.departRightTree.queryTreeNodeByID(res[0].id);
                    if (Array.isArray(nodes) && nodes[0]) {
                        this.rightLimbCheckedId = res[0].id; // 设置"已分配"树选中的部门id
                        this.$refs.departRightTree.setNodeSelect(nodes[0], true); // 设置该部门节点背景选中
                    }
                }

                this.rightDataTotal = this.$refs.departRightTree.getAllNodes(
                    false,
                    false
                ).data.length;
            });
        },

        // 处理后台数据，每条数据加入 children 属性，默认为 []
        handleData(res) {
            res.forEach(item => {
                if (item.children) {
                    this.handleData(item.children);
                } else {
                    this.$set(item, "children", []);
                }
            });
            return res;
        },
        // 重置"已分配"树状态
        resetLeft() {
            this.leftFilterText = "";
            // this.leftDataTotal = 0;
            this.leftLimbCheckedId = "";
            this.leftCheckedData = [];
            this.leftCheckedAll = false;
            this.leftIndeterminate = false;
        },

        // 重置右侧列表状态
        resetRight() {
            this.rightFilterText = "";
            // this.rightDataTotal = 0;
            this.rightLimbCheckedId = "";
            this.rightCheckedData = [];
            this.rightCheckedAll = false;
            this.rightIndeterminate = false;
        }
    }
};
